import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgResizeIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 6 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6 16L6 0L4 -8.74228e-08L4 16L6 16ZM0 -2.62268e-07L-6.99382e-07 16L2 16L2 -1.74846e-07L0 -2.62268e-07Z",
		fill: "#8ea1b8"
	})
});
export default SvgResizeIcon;
